import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getProductMasterByIdApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getProductMasterById = createAsyncThunk('getProductMasterById', async (payload) => {
  // console.log('payload', payload);
  return await getProductMasterByIdApi(payload);
});

const getProductMasterByIdSlice = createSlice({
  name: 'getProductMasterById', // Unique Name
  initialState,
  reducers: {
    getProductMasterByIdReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProductMasterById.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getProductMasterById.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getProductMasterById.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getProductMasterByIdReset } = getProductMasterByIdSlice.actions;

export default getProductMasterByIdSlice.reducer;
